import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "redux/app/hooks";
import { moneyMask } from "utils/mask";
import { SecurityPageProps } from "models/security";

const CreditInstallment = (props: any) => {
  const history = useHistory();

  const {
    cliente: { valuePaymentInvoice, invoiceInstallmentCalculation, valueAntecipationPurchase },
  } = useAppSelector((state) => state.cliente);

  const clickBack = () => {
    history.push(RouteNames.ATENDIMENTO_FATURA);
  };

  const handleSubmit = (parcelas: string) => {
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.FEEDBACK_FATURA_PINPAD,
      backStep: RouteNames.ESCOLHA_PAGAMENTO,
      installmentPaymentInvoice: parcelas,
      title: "Pagar com cartão de crédito",
      description:
        "Tudo certo! Agora confirme no Pinpad o valor selecionado e aproxime ou insira o teu cartão de crédito.",
    };

    history.push({
      pathname: RouteNames.FEEDBACK_FATURA_PINPAD,
      state: { ...propsRouter },
    });
  };

  return (
    <ContainerFlex>
      <St.TitleH1>Pagamento</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>
            {`O `}
            <St.SpanDescriptionBold>
              {`pagamento de ${moneyMask(Number(valuePaymentInvoice || valueAntecipationPurchase))}`}
            </St.SpanDescriptionBold>
            {` pode ser parcelado em até ${invoiceInstallmentCalculation?.parcelas}x. com juros de ${invoiceInstallmentCalculation?.taxaJuros}% a.m. . Escolha a quantidade de parcelas para continuar:`}
          </St.SpanDescription>
          <ContainerFlex row width={100} center horizontal flexFlow="wrap">
            {invoiceInstallmentCalculation &&
              invoiceInstallmentCalculation.detalhesParcelas?.map(
                (invoiceInstallmentLine) => (
                  <ContainerFlex maxWidth={15} padding={10}>
                    <button
                      style={{ maxWidth: "100%" }}
                      className="normal"
                      onClick={() =>
                        handleSubmit(String(invoiceInstallmentLine.parcelas))
                      }
                    >
                      {`${invoiceInstallmentLine.parcelas}x ${moneyMask(
                        invoiceInstallmentLine.valor
                      )}`}
                    </button>
                  </ContainerFlex>
                )
              )}
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space>
        <ContainerFlex>
          <AppButton content="Voltar" outlined={true} click={clickBack} />
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default CreditInstallment;
